import React, { createContext, useEffect } from 'react';
import { message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';

export const MessageContext = createContext<MessageInstance | null>(null);

export type MessageParams = {
  type?: 'success' | 'error' | 'info' | 'warning' | 'loading';
  content: React.ReactNode;
  duration?: number;
  key?: string | number;
  onClose?: () => void;
};

export let showMessage: (params: MessageParams) => void = () => {
  console.warn('Message not initialized');
};

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [api, contextHolder] = message.useMessage();

  useEffect(() => {
    showMessage = ({ type = 'info', ...rest }: MessageParams) => {
      api[type]({
        duration: 3,
        ...rest,
      });
    };
  }, [api]);

  return (
    <MessageContext.Provider value={api}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};
